
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.871 0A.871.871 0 000 .871a.871.871 0 00.871.87h6.968a.871.871 0 00.87-.87A.871.871 0 007.84 0zm9.29 0a.871.871 0 00-.87.871.871.871 0 00.87.87h6.968A.871.871 0 0018 .872.871.871 0 0017.129 0zm-8.71 3.484a.871.871 0 00-.87.87V17.13a.871.871 0 00.87.871h5.807a.871.871 0 00.871-.871V4.355a.871.871 0 00-.87-.871zm9.29 0a.871.871 0 00-.87.87v6.969a.871.871 0 00.87.87h5.807a.871.871 0 00.871-.87V4.355a.871.871 0 00-.87-.871zM2.324 5.226h4.064v11.032H2.323zm9.29 0h4.064v5.226h-4.064z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    